import { Component } from 'react';
import url from 'url';
import _ from 'lodash';
import { pushHistoryState } from '../../helpers/routing';

export default class TableBaseComponent extends Component {
  getActivePage = () => {
    const { page } = url.parse(window.location.href, true).query;
    const pageNumericValue = parseInt(page, 10);

    if (!pageNumericValue) {
      return 0;
    }

    const pageIndex = pageNumericValue - 1;

    return pageIndex > 0 ? pageIndex : 0;
  };

  loadData = (activePage, getDataAction, pageSize, customData, customUrl) => {
    this.setState({ loading: true });
    const { match: { path } } = this.props;
    getDataAction(activePage * pageSize, customData).then(({ data, pagesQuantity }) => {
      if (data) {
        const activePageValue = activePage + 1;
        if (activePage !== 0 && activePageValue > pagesQuantity) {
          return this.loadData(0, getDataAction, pageSize, customData, customUrl);
        }
        const newUrl = customUrl ? `${customUrl}&page=${activePageValue}` : `${path}?page=${activePageValue}`;
        this.setData(activePage, newUrl);
      }
    });
  };

  setData = (activePage, path) => {
    this.setState({
      data: this.props.initialData,
      columns: this.columnRenderer(this.props.initialData),
      loading: false,
      activePage
    }, () => pushHistoryState(path));
  };

  saveFilter = filteringFieldsList => {
    this.setState({
      filteringFieldsList
    });
  };

  filterData = () => {
    const { initialData } = this.props;
    const { filteringFieldsList } = this.state;
    let filteredData = initialData;
    if (filteringFieldsList.length) {
      filteringFieldsList.forEach(filteredField => {
        if (filteredField.value === 'all') return;
        const columnName = filteredField.id;
        const inputValue = filteredField.value.toString().toLowerCase();
        filteredData = filteredData.filter(tableEntry => {
          if (tableEntry[columnName] !== undefined) {
            return tableEntry[columnName].toString().toLowerCase().includes(inputValue);
          }
          return false;
        });
      });
    }
    return filteredData;
  };

  handleSorting = sortedColumn => {
    const { data } = this.state;
    const { desc } = sortedColumn[0];
    const order = desc ? 'desc' : 'asc';
    const fieldName = sortedColumn[0].id;
    this.setState({
      data: _.orderBy(data, [fieldName], [order])
    });
  };

  navToDetails = (state, rowInfo) => ({
    onClick: () => {
      const { id } = rowInfo.original;
      const { history, match: { path } } = this.props;
      history.push(`${path}/${id}`);
    },
    style: { cursor: 'pointer' }
  });

  render () {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/common/TableBaseComponent.js